import React, { useMemo } from 'react'
import { Box, Tooltip } from '@maui/elements'
import { formatDate } from '../../utilities/dates'

export const NameWithSeenTooltip = ({ name, Icon, flagProps, firstSeen, lastSeen, type }) => {
  const cursorTypeMap = {
    industries: 'default',
    targetLocations: 'default'
  }

  const seen = useMemo(() => {
    return [
      ['First seen:', firstSeen],
      ['Last seen:', lastSeen],
    ].reduce((seen, [label, date], i) => {
      const formatted = formatDate(date)
      if (formatted) {
        seen.push(
          <Box key={i}>
            <Box as="span" fontWeight="bold">
              {label}
            </Box>
            {' '}
            {formatted}
          </Box>
        )
      }
      return seen
    }, [])
  }, [firstSeen, lastSeen])

  if (!name) {
    return null
  }

  return (
    <Tooltip
      size="large"
      display="flex"
      lineHeight="18px"
      gap="spaceGapMedium"
      cursor={cursorTypeMap[type]}
      tooltip={<>
        <Box fontWeight="bold" mb={seen.length ? '10px' : 0}>
          {name}
        </Box>
        {seen}
      </>}
    >
      <Icon {...flagProps} />
      <Box>{name}</Box>
    </Tooltip>
  )
}
